export * from "./admin-portal";
export * from "./physician-portal";
export * from "./clear-search.guard";
export * from "./patient-portal";



// WEBPACK FOOTER //
// ./src/app/shared/guard/index.ts